const devMode = process.env.NODE_ENV === "development";

const config = {
    APP_NAME: "CAMPUS | Paulo Cunha e Silva",
    DEV: devMode,
    TIMEOUT: 60000,
    HAS_LOGIN: true,
    LOGIN_PATH: "/",
    ANALYTICS_ID: "UA-199753108-1"
};

export default config;
